import React from 'react'
import { Avatar, Col, Row } from 'antd'
import Learningchart from '../studentprofilemain/charts/earningchart'

const Studentleaderboard = () => {
  return (
    <div>
      <Row gutter={16}>
        <Col xs={24} md={24} lg={12}>
          <div>
            <div className='flex px-[3rem] items-end pt-10'>
              <div className='relative flex flex-col grow'>
                <div className='rounded-full absolute top-[-2.5rem] left-[1.5rem]'>
                  <img src="/img/vectors/userfemale.svg" className='rounded-full h-[4.3rem]' alt="" />
                </div>
                <div className='custom-primary-bg-four min-h-[8.8rem] flex flex-col justify-center content-end custom-box-shadow-four'
                  style={{
                    borderRadius: '25px 0px 0px 16px'
                  }}
                >
                  <p className='text-[50px] leading-[107%] font-bold text-appcolorwhite text-center'>
                    2
                  </p>
                </div>
                <p className='text-center text-appcolorblack text-[20px] leading-[107%] mt-[0.5rem] font-semibold'>Abel</p>
              </div>

              <div className='relative flex flex-col grow'>
                <div className='rounded-full absolute top-[-2.5rem] left-[1.5rem]'>
                  <img src="/img/vectors/userfemale.svg" className='rounded-full h-[4.3rem]' alt="" />
                </div>
                <div className='custom-primary-bg-four min-h-[10.7rem] flex flex-col justify-center content-end'
                  style={{
                    borderRadius: '25px 25px 0px 0px'
                  }}
                >
                  <p className='text-[50px] leading-[107%] font-bold text-appcolorwhite text-center'>
                    1
                  </p>
                </div>
                <p className='text-center text-appcolorblack text-[20px] leading-[107%] mt-[0.5rem] font-semibold'>Abel</p>
              </div>


              <div className='relative flex flex-col grow'>
                <div className='rounded-full absolute top-[-2.5rem] left-[1.5rem]'>
                  <img src="/img/vectors/userfemale.svg" className='rounded-full h-[4.3rem]' alt="" />
                </div>
                <div className='custom-primary-bg-four min-h-[7.5rem] flex flex-col justify-center content-end'
                  style={{
                    borderRadius: '0px 25px 16px 0px'
                  }}
                >
                  <p className='text-[50px] leading-[107%] font-bold text-appcolorwhite text-center'>
                    3
                  </p>
                </div>
                <p className='text-center text-appcolorblack text-[20px] leading-[107%] mt-[0.5rem] font-semibold'>Abel</p>
              </div>

            </div>

            <div className='mt-[2.3rem]'>
              <div>
                {
                  [1, 3, 43, 54].map((item) => (
                    <div
                      key={`fpt-${item}`}
                      className='flex items-center justify-between p-4 hover:bg-appcolororangefaint hover:rounded-[10px] mb-0'>
                      <div className='flex items-center'>
                        <p className='rounded-[7px] bg-appcolorpurplefour py-[0.2rem] px-[0.6rem] mr-2 text-appcolorwhite'>
                          1
                        </p>

                        <div className='flex items-center'>
                          <Avatar
                            src="/img/vectors/userfemale.svg"
                            style={{
                              border: '2px solid #FBE0FF',
                              borderRadius: '50%',
                              width: '3rem',
                              height: '3rem',
                            }}
                          />

                          <div className='ml-3'>
                            <p className='text-base text-appcolorblack  font-semibold mb-1'>Ella</p>
                            <p className='text-base text-appcolorblack  font-semibold opacity-[0.5]'>ellie123</p>
                          </div>
                        </div>
                      </div>


                      <div className=''>
                        <p className='text-base text-appcolorblack font-semibold mb-1'>
                          40000FP
                        </p>
                      </div>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        </Col>
        <Col xs={24} md={24} lg={12}>
          <div>
            <div className='mb-12'>
              <p className='text-[18px] text-appcolorblack leading-[107%] font-semibold mb-2'>
                Funpoint Earning
              </p>

              <div>
                <Learningchart />
              </div>
            </div>

            <div>
              <div className='rounded-[30px] px-[1.25rem] py-[1.5rem] custom-apple-bg-linear flex'>
                <div className='rounded-[20px] text-[20px] leading-[107%] text-appcolorwhite custom-white-bg-faint py-[1.2rem] px-[0.7rem]'>
                  #<span className='font-bold'>20</span>
                </div>
                <div className='pl-[0.8rem]'>
                  <p className='text-base font-bold text-appcolorwhite'>Earn More Points Now!</p>
                  <p className='text-appcolorwhite'>
                    Get more points to move up on the leaderboard
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default Studentleaderboard